import { Injectable } from '@angular/core';
// import { UserService } from './user.service';
import { RestService } from './lib/RestService';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import UIkit from './lib/uikit';
// const io = require('socket.io-client');

@Injectable()
export class ConsultService extends RestService {
  // io: any;
  notifications: any[] = [];
  unreaded = 0;
  private apiUrl = `${environment.apiUrl}Notification/`;

  constructor(
    // private userService: UserService,
    private http: HttpClient
  ) {
    super();
    // this.io = io(WS_SERVER);
    // this.io.on('notification', (n: any) => this.notification(n));
    // this.userService.onSignIn.push(() => this.join());
    // this.userService.onSignIn.push(() => this.getNotifications());
    // this.userService.onSignOut.push(() => this.leave());
  }

  // join() {
  //   this.io.emit('join', this.userService.user.ID);
  // }

  // leave() {
  //   this.io.emit('leave', this.userService.user.ID);
  // }

  getNotifications() {
    // Get last 20 notifications
    return this.http.get(
        `${this.apiUrl}?limit=20&sort=-createdAt`,
        { withCredentials: true }
      )
      .toPromise()
      .then((res: any[]) => {
        this.notifications = res.reverse();
        this.countUnreaded();
      })
      .catch(this.handleError);
  }

  countUnreaded() {
    this.unreaded = this.notifications.filter((n) => !n.isReaded).length;
  }

  notification(n: any) {
    this.notifications.push(n);
    this.countUnreaded();
    UIkit.notification({
      message: n.name || n.text,
      status: n.status || 'info',
      pos: 'bottom-left'
    });
  }

  readNotification(n: any) {
    if (n.isReaded) return;

    const setReaded = () => {
      n.isReaded = true;
      this.countUnreaded();
    };

    if (!n._id) return setReaded();

    this.http.patch(`${this.apiUrl}/${n._id}`,
      {isReaded: true}, { withCredentials: true })
      .toPromise()
      .then((res: any) => setReaded())
      .catch(this.handleError);
  }
}
